import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-josephus',
  imports: [RouterLink, Biggen, Link],
  templateUrl: './josephus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './josephus.scss',
})
export class Josephus {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Josephus`);
    this.dynamicTitle.description(`Josephus is cited as a non-Christian source mentioning Jesus, but scholars widely view his brief, ambiguous references as later Christian interpolations.`);
  }
}
